import { FC } from "react";
import { Link } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import __ from "src/utils/Translations";
import useBasePath from "src/utils/hooks/useBasePath";
import Avatar from "src/Components/Avatar";
import { IEmployeeDetails } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";

interface IEmployeeDetailsProps {
  data: IEmployeeDetails;
  showFk: boolean;
  error?: string;
}

const EmployeeDetails: FC<IEmployeeDetailsProps> = ({
  data,
  showFk = false,
  error,
}) => {
  const basePath = useBasePath();

  if (!data) return null;

  return (
    <List sx={{ opacity: data.active === false ? 0.5 : 1 }}>
      <ListItem disableGutters>
        <ListItemAvatar sx={{ marginRight: 2 }}>
          <Link to={`${basePath}/employees/${data.employeeId}`}>
            <Avatar
              size="64px"
              employeePresence={data.presenceStatus}
              initials={data.initials}
              src={data.avatarUrl}
            />
          </Link>
        </ListItemAvatar>
        <ListItemText
          primary={
            <Typography variant="h5">
              {data.firstName} {data.lastName}
            </Typography>
          }
          secondary={
            <>
              <Typography variant="body2">
                {data.position || __("Brak stanowiska")}
              </Typography>
              {showFk && (
                <Typography variant="body2">
                  {__("Numer pracownika")}: <strong>{data.fkNumber}</strong>
                </Typography>
              )}
            </>
          }
        />
      </ListItem>
      {error && (
        <ListItem disableGutters disablePadding>
          <ListItemText
            primary={
              <Typography variant="caption" color="error">
                {error}
              </Typography>
            }
            sx={{
              maxWidth: "500px",
            }}
          />
        </ListItem>
      )}
    </List>
  );
};

export default EmployeeDetails;
